import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";

import "./styles/MessageList.css";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

import * as actions_message from "../redux/actions/messageActions";
import * as actions_event from "../redux/actions/eventActions";

import MiniLoader from "./MiniLoader";
import ServerSeen from "./Serverseen";
import formatDate from "../utils/Date";
import formatHour from "../utils/Hour";

var date = new Date(1900, 1, 1).toDateString("en-US", {
  day: "2-digit",
  month: "2-digit",
  year: "2-digit",
});

function setDate(props) {
  date = props.item.created_at;
  return true;
}

function isLess(date1, date2) {
  const fecha1 = new Date(date1);
  const fecha2 = new Date(date2);

  if (fecha1.getFullYear() < fecha2.getFullYear()) return true;
  if (fecha1.getMonth() < fecha2.getMonth()) return true;
  if (fecha1.getDate() < fecha2.getDate()) return true;

  return false;
}

function MessageContent({ item }) {
  const hasText = Boolean(item.text && item.text.trim());
  const hasFile = Boolean(item.file_url);

  return (
    <React.Fragment>
      {hasFile && item.file_type === "image" && (
        <a
          href={item.file_url}
          target="_blank"
          rel="noopener noreferrer"
          className="chat-msg__attachment-link"
        >
          <img
            src={item.file_url}
            alt={item.file_name || "attachment"}
            className="chat-msg__attachment-image"
          />
        </a>
      )}
      {hasFile && item.file_type !== "image" && (
        <a
          href={item.file_url}
          target="_blank"
          rel="noopener noreferrer"
          className="chat-msg__attachment-file"
        >
          {item.file_name || <Translate value="chat_attachment" />}
        </a>
      )}
      {hasText && <p className="chat-msg__text">{item.text}</p>}
    </React.Fragment>
  );
}

function MessageItemContact({ item }) {
  return (
    <div className="chat-msg chat-msg--in">
      {isLess(date, item.created_at) && setDate({ item }) && (
        <span className="chat-msg__date">{formatDate(item)}</span>
      )}
      <div className="chat-msg__row">
        <img
          src={item.user.avatar}
          className="chat-msg__avatar"
          alt=""
        />
        <div className="chat-msg__bubble">
          <MessageContent item={item} />
          <span className="chat-msg__time">{formatHour(item)}</span>
        </div>
      </div>
    </div>
  );
}

function MessageItemMe({ item }) {
  return (
    <div className="chat-msg chat-msg--out">
      {isLess(date, item.created_at) && setDate({ item }) && (
        <span className="chat-msg__date">{formatDate(item)}</span>
      )}
      <div className="chat-msg__row">
        <div className="chat-msg__bubble">
          <MessageContent item={item} />
          <span className="chat-msg__time">{formatHour(item)}</span>
        </div>
        <img
          src={item.user.avatar}
          className="chat-msg__avatar"
          alt=""
        />
        <div className="chat-msg__status">
          <ServerSeen seen={item.is_seen} server={item.is_server} />
        </div>
      </div>
    </div>
  );
}

class MessageList extends React.Component {
  onClickLoadMore = async () => {
    try {
      await this.props
        .LoadMoreMessages(this.props.token, {
          index: this.props.pageCount,
          conversation_id: this.props.contact.ConversationId,
          id: this.props.user_id,
          lang: I18n.t("locale"),
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { messageList } = this.props;

    if (!messageList || messageList.length === 0) {
      return (
        <div className="chat-messages__empty">
          <Translate value="message_not_list" />
        </div>
      );
    }

    date = new Date(1900, 1, 1);

    return (
      <div className="chat-messages">
        {this.props.pageSize > 7 &&
          (this.props.loadingMore ? (
            <div className="chat-messages__load-more">
              <MiniLoader />
            </div>
          ) : (
            <div className="chat-messages__load-more">
              <button
                type="button"
                className="chat-messages__load-more-btn"
                onClick={this.onClickLoadMore}
              >
                <Translate value="load_more" />
              </button>
            </div>
          ))}

        {messageList.map((item) => {
          if (
            item.user.id.toString() !== this.props.user_id &&
            item.is_seen !== 0
          ) {
            item.is_seen = 0;
            this.props.contact.Socket !== "" &&
              this.props.UpdateMessageReadEvent(item);
            this.props.UpdateMessageReadMessage(this.props.token, {
              message_id: item.id,
              id: this.props.user_id,
              lang: I18n.t("locale"),
            });
          }

          return item.user.id.toString() === this.props.user_id ? (
            <MessageItemMe item={item} key={item.id} />
          ) : (
            <MessageItemContact item={item} key={item.id} />
          );
        })}
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    messageList: reducer.message.list,
    pageCount: reducer.message.page_count,
    pageSize: reducer.message.page_size,
    loadingMore: reducer.message.loadingMore,
    error: reducer.message.error,
    contact: reducer.contacts.item,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadMoreMessages: (token, params) =>
    dispatch(actions_message.loadListScroll({ token, params })),
  UpdateMessageReadMessage: (token, params) =>
    dispatch(actions_message.updateMessageRead({ token, params })),
  UpdateMessageReadEvent: (item) =>
    dispatch(actions_event.updateMessageRead(item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MessageList);
